export type PeerStatus = "connecting" | "connected";

export type RoomPeer = {
  peerId: string;
  displayName: string;
  deviceName: string;
  status: PeerStatus;
  connectionHash?: string;
};

export type PeersState = Record<string, RoomPeer>;

export type PeerAction =
  | { kind: "joined"; peer: { peerId: string; displayName?: string; deviceName?: string } }
  | { kind: "connected"; peerId: string; connectionHash: string }
  | { kind: "disconnected"; peerId: string }
  | { kind: "renamed"; peerId: string; displayName: string };

export function peersReducer(state: PeersState, action: PeerAction): PeersState {
  switch (action.kind) {
    case "joined": {
      const existing = state[action.peer.peerId];
      return {
        ...state,
        [action.peer.peerId]: {
          peerId: action.peer.peerId,
          displayName: action.peer.displayName ?? existing?.displayName ?? "",
          deviceName: action.peer.deviceName ?? existing?.deviceName ?? "",
          status: existing?.status ?? "connecting",
          connectionHash: existing?.connectionHash,
        },
      };
    }
    case "connected": {
      const existing = state[action.peerId];
      return {
        ...state,
        [action.peerId]: {
          peerId: action.peerId,
          displayName: existing?.displayName ?? "",
          deviceName: existing?.deviceName ?? "",
          status: "connected",
          connectionHash: action.connectionHash,
        },
      };
    }
    case "disconnected": {
      if (!state[action.peerId]) return state;
      const next = { ...state };
      delete next[action.peerId];
      return next;
    }
    case "renamed": {
      const existing = state[action.peerId];
      if (!existing) return state;
      return { ...state, [action.peerId]: { ...existing, displayName: action.displayName } };
    }
  }
}
